import * as React from 'react';
import Modal from "react-responsive-modal";
import Input from '../../../../../common/Input/Input'
import InputUtils, {Type} from "../../../../../../InputUtils";
import './createGroupModal.css'
import Utils from "../../../../../../Utils";

interface Props {
    createGroup(group): void,

    editGroup(dto): void,

    restoreEventListener(): void,

    hideModal(): void,

    showModal: boolean,
    selectedGroup: any,
    modalData: any,
}

interface State {
    validateForm: boolean;
    formIsValid: boolean;
    form: any,
}

enum DEFAULT_ERROR_MSG {
    GROUP_NAME = 'Name field cannot be empty',
    ROLES = 'Roles field cannot be empty',
}

class CreateGroupModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            validateForm: false,
            formIsValid: true,
            form: {
                groupName: {
                    value: '',
                    valid: true,
                    errorMsg: DEFAULT_ERROR_MSG.GROUP_NAME
                },
                roles: {
                    value: '',
                    valid: true,
                    errorMsg: DEFAULT_ERROR_MSG.ROLES,
                    options: [],
                },
            }
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (this.props.showModal && this.props.modalData.roles !== prevProps.modalData.roles) {
            this.resetForm();
            document.addEventListener('keydown', this.keydownModalHandler);
            setTimeout(() => {
                this.loadDataToForm();
            }, 100)
        }
        if (this.props.showModal !== prevProps.showModal && !this.props.showModal) {
            document.removeEventListener('keydown', this.keydownModalHandler);
        }
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownModalHandler);
    }

    keydownModalHandler = (e) => {
        if (e.keyCode === 13 && !e.target.id.includes('select')) {
            Utils.$('#btn-save').click();
        }
    }

    loadDataToForm = () => {
        let formCopy = JSON.parse(JSON.stringify(this.state.form));
        this.loadDropDownOptions(formCopy);
        if (this.props.selectedGroup) {
            const selectedGroup = JSON.parse(JSON.stringify(this.props.selectedGroup));
            const keys = Object.keys(selectedGroup);

            keys.forEach(key => {
                if (formCopy.hasOwnProperty(key)) {
                    if (key.toLowerCase() === 'roles') {
                        formCopy = {
                            ...formCopy,
                            [key]: {
                                ...formCopy[key],
                                value: this.getLoadedDropDownValues(selectedGroup[key], key)
                            }
                        }
                    } else {
                        formCopy = {
                            ...formCopy,
                            [key]: {
                                ...formCopy[key],
                                value: selectedGroup[key] ? selectedGroup[key] : ''
                            }
                        }
                    }
                }
            })
        }

        this.setState({
            form: formCopy
        })
    }

    loadDropDownOptions = (form?: any) => {
        if (this.props.modalData.roles.length > 0) {
            if (form) {
                form.roles.options = this.props.modalData.roles;
            } else {
                let formCopy = JSON.parse(JSON.stringify(this.state.form));
                formCopy.roles.options = this.props.modalData.roles;
                this.setState({
                    form: formCopy
                })
            }
        }
    }

    getLoadedDropDownValues = (values: any, field: string) => {
        const {modalData} = this.props;
        let found = [];
        values.forEach(val => {
            let searched = modalData[field].find(item => {
                return item.label.toLowerCase() === val.roleName.toLowerCase()
            })
            if (searched) {
                found.push(searched);
            }
        })
        return found;
    }

    open = () => {
        this.resetForm();
        this.setState({
            formIsValid: true,
            validateForm: false,
        });
    };

    resetForm = () => {
        this.setState({
            form: InputUtils.resetForm(this.state.form)
        })
    }

    close = () => {
        this.resetForm();
        this.props.hideModal();
        this.props.restoreEventListener()
    };

    onChange = (event, id, inputType) => {
        const formCopy = JSON.parse(JSON.stringify(this.state.form));
        let eventValue;
        if (inputType.includes('select')) {
            eventValue = event ? event : [];

        } else {
            eventValue = event.target.value;
        }
        this.setValueToForm(formCopy, id, eventValue);
    }

    setValueToForm = (formCopy: any, id: string, eventValue: any, errorMsg?: any) => {
        if (errorMsg) {
            this.setState({
                form: {
                    ...formCopy,
                    [id]: {
                        ...formCopy[id],
                        value: eventValue,
                        valid: false,
                        errorMsg: errorMsg
                    }
                }
            })
        } else {
            this.setState({
                form: {
                    ...formCopy,
                    [id]: {
                        ...formCopy[id],
                        value: eventValue,
                        valid: true,
                        errorMsg: this.getDefaultErrorMsg(id)
                    }
                }
            })
        }
    }

    getDefaultErrorMsg = (id: string) => {
        if (id === 'groupName') {
            return DEFAULT_ERROR_MSG.GROUP_NAME;
        }
        if (id === 'roles') {
            return DEFAULT_ERROR_MSG.ROLES
        }
    }


    createEditHandler = () => {
        if (this.checkFormValidity()) {
            let dto;
            if (this.props.selectedGroup === null) {
                dto = {
                    selectedRoles: this.state.form.roles.value,
                    groupName: this.state.form.groupName.value
                }
                this.props.createGroup(dto)
            } else {
                const removedRoles = [];
                const addedRoles = [];
                this.props.selectedGroup.roles.forEach(item => {
                    const found = this.state.form.roles.value.find(role => role.label === item.roleName)
                    if (!found) {
                        removedRoles.push(item.id);
                    }
                })

                this.state.form.roles.value.forEach(item => {
                    const found = this.props.selectedGroup.roles.find(role => role.roleName === item.label)
                    if (!found) {
                        addedRoles.push(item.id);
                    }
                });
                dto = {
                    groupId: this.props.selectedGroup.id,
                    groupName: this.state.form.groupName.value,
                    removedRoles: removedRoles,
                    addedRoles: addedRoles
                }
                this.props.editGroup(dto)
            }
            this.props.restoreEventListener();
        }
    }

    checkFormValidity = (): boolean => {
        const keys = Object.keys(this.state.form);
        const formCopy = JSON.parse(JSON.stringify(this.state.form));
        let formIsValid = true;
        keys.forEach((key, index) => {
            if (key === 'groupName') {
                if ((formCopy[key].value === '' || this.checkIsNameUnique(formCopy[key].value)) || !formCopy[key].valid) {
                    formCopy[key].valid = false;
                    if (formCopy[key].value !== '') {
                        formCopy[key].errorMsg = `${formCopy[key].value} is already used`;
                    }
                    formIsValid = false;
                }
            }
            if (key === 'roles') {
                if (formCopy[key].value.length === 0) {
                    formCopy[key].valid = false;
                    formIsValid = false;
                }
            }
        })

        this.setState({
            form: formCopy
        })

        return formIsValid;
    }

    checkIsNameUnique = (name: string) => {
        if (this.props.modalData.usedNames.length > 0) {
            if (this.props.selectedGroup &&
                this.props.selectedGroup.groupName === this.state.form.groupName.value) {
                return false;
            }
            return this.props.modalData.usedNames.includes(name);
        }
        return false;
    }

    render() {
        return (
            <Modal
                open={this.props.showModal}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: 600,
                        padding: 0,
                        maxWidth: 600,
                    }
                }}
                closeOnEsc={true}
                onClose={this.close}
                center
                focusTrapped={true}
                closeOnOverlayClick={false}
            >
                <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                    <div className="row" style={{height: '100%'}}>
                        <div id={'create-role-container'} className='col-lg-12 compare-changes'>
                            <header className={'create-group-modal-header'}>
                                <h2>{this.props.selectedGroup ? 'Edit Group' : 'Create Group'}</h2>
                            </header>
                            <div className={'create-group-modal-container'}>
                                <div className={'createGroupForm'}>
                                    <Input id={'group-name'}
                                           value={this.state.form.groupName.value}
                                           required={true}
                                           elementType={Type.INPUT}
                                           changed={(event) => this.onChange(event, 'groupName', 'input')}
                                           classNameProp={'input-full-width default-margin-inputs'}
                                           valid={this.state.form.groupName.valid}
                                           errorMsg={this.state.form.groupName.errorMsg}
                                           label={'Group Name'}
                                           elementConfig={{
                                               placeholder: 'Group Name',
                                               tabIndex: 1
                                           }}
                                    />
                                    <Input id={'react-select'}
                                           value={this.state.form.roles.value}
                                           required={true}
                                           elementType={Type.SELECT}
                                           changed={(event) => this.onChange(event, 'roles', 'select')}
                                           classNameProp={'input-full-width default-margin-inputs custom-select-menu-initial-position'}
                                           errorMsg={this.state.form.roles.errorMsg}
                                           valid={this.state.form.roles.valid}
                                           selectInitialPosition={true}
                                           label={'Role'}
                                           elementConfig={{
                                               placeholder: 'Select Role',
                                               tabIndex: 2,
                                               options: this.state.form.roles.options,
                                               closeMenuOnSelect: false,
                                               isMulti: true
                                           }}
                                    />
                                </div>
                            </div>
                            <footer style={{
                                background: "#2D3436",
                                borderTop: "2px solid #f5f5f5a3",
                                height: 49,
                                width: "100%",
                                paddingRight: 5,
                                paddingTop: 3,
                            }}>
                                <button
                                    onClick={this.createEditHandler}
                                    className={"btn"}
                                    id={'btn-save'}
                                    style={{float: "right", marginTop: 3, marginLeft: 4}}>
                                    <i className="fas fa-save"> Save</i>
                                </button>
                                <button
                                    onClick={this.close}
                                    className={"btn"}
                                    style={{float: "right", marginTop: 3, marginRight: 2}}>
                                    <i className="fas fa-times"> Close</i>
                                </button>
                            </footer>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default CreateGroupModal



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/GroupsGrid/components/createGroupModal/CreateGroupModal.tsx